module.exports = __webpack_public_path__ + "img/zaire.8c71a93.webp";